import { marker } from '@jsverse/transloco-keys-manager/marker';
import { HomeStatistics } from './home-statistics';

export const homeStatistics: HomeStatistics[] = [
  {
    label: marker('Mes séquences créées'),
    icon: '@tui.camera',
    value: 'sequenceCount',
    color: 'pixablue',
    link: 'sequences',
  },
  {
    label: marker('Mes photographies médicales'),
    icon: '@tui.image',
    value: 'mediaCount',
    color: 'pixapurple',
    link: 'sequences',
  },
  {
    label: marker('Mes patients traités'),
    icon: '@tui.user',
    value: 'treatedPatientCount',
    color: 'pixared',
    link: 'patients',
  },
];
